import RecoverStep from "../recover_step";
import {
    attachContactSupportHandler,
    attachRowHandler, getExposedMount,
    isExportToDisk,
    toArray
} from "../../utils/recover_utils";
import {AJAX_DATA_TYPE_JSON} from "../../utils/recover_consts";
import {ZERO} from "../../../../modules/constants";

const TEMPLATE = 'devices';
const EXPORT_TYPES = [
    'vhdx-export',
    'vhd-export',
    'vm-export'
];

export default class SetDevice extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    open(data, el, fr, previousStep) {
        const renderDevices = function () {
            data.tmp.previousStep = fr.currentStep;
            data.render.canRecover = true;
            data.render.disabledDeviceStatuses = ["FAILOVER_TEST_VM_RUNNING", "FAILOVER_TEST_VM_PAUSED", "FAILOVER_TEST_VM_READY"];

            if (data.deviceId) {
                data.recovery.device_id = data.device.id;
                data.recovery.device_name = data.device.name;
                data.recovery.device_asid = data.devices[data.deviceId].info.appliance_assigned_id;
                data.recovery.appliance_id = data.devices[data.deviceId].info.appliance_id;

                if (isExportToDisk(data)) {
                    fr.callMethod("checkVMStatus");
                } else {
                    fr.goTo('setJob');
                }
            } else {
                data.render.searchComplete = true;
                fr.render("setDevice");
            }
        };

        if (data.recovery.device_id) {
            fr.callMethod('checkVMStatus');
            return;
        }

        data.render = {
            searchComplete : false,
            exportVM       : (isExportToDisk(data)),
            exportVHD      : (data.recovery.virtualization && data.recovery.virtualization.isVHD),
            exportVHDX     : (data.recovery.virtualization && data.recovery.virtualization.isVHDX)
        };

        //Since we have virtualization location as a possible previous step, need to test appropriately
        data.render.showOffsite = (data.restore && data.restore.type && (data.restore.type === "cloud"));
        data.render.canRecover = false;

        $.ajax({
            type : "GET",
            url : this.getUrl(data),
            success: function (response) {
                data.devices = response.data;
                if ($.isEmptyObject(data.devices) || (data.deviceId && !data.devices[data.deviceId])) {
                    data.render.searchComplete = true;
                    fr.render("setDevice");
                } else {
                    data.tmp.devices_arr = toArray(data.devices);
                    renderDevices();
                }
            },
            dataType: AJAX_DATA_TYPE_JSON,
            contentType: "application/json"
        }).fail(fr.defaultAJAXErrorHandler);
    }

    postRender(data, el, fr) {
        const $el = $(el);
        if (data.render.searchComplete) {
            attachRowHandler(el);
            attachContactSupportHandler(data, el, fr);
            alignHeaderOnLimitedHeightTable($el);
            $el.find('thead th:eq(2)').click();
        }
        $el.find('tbody tr').on('click', function() {
            const selected_row = $(this);
            data.tmp.previousStep = fr.currentStep;

            const selected_device_id = selected_row.find('input').val(),
                disabled = selected_row.data("disable_row");
            data.recovery.device_asid = data.devices[selected_device_id].info.appliance_assigned_id;
            data.recovery.device_name = selected_row.find('td:eq(2)').text();
            data.recovery.appliance_id = selected_row.find('input').data('appliance_id');

            // do we have information for this device? (for offsite file browsing, we get the device list from data center and then match to our db if possible)
            if (data.devices[selected_device_id].info && !disabled) {
                data.recovery.device_id = data.devices[selected_device_id].info.id;
            }
            if (isExportToDisk(data)){
                if (!disabled) {
                    fr.callMethod("checkVMStatus")
                }
            }
            else {
                fr.goTo('setJob');
            }
        })
    }

    transitionBack(data, el, fr) {
        if (isExportToDisk(data)) {
            fr.goTo('setExportType');
        }
        else if (data.appliances && data.appliances.length > 1) {
            fr.goTo('setAppliance');
        }
        else {
            fr.goTo('restoreType');
        }
    }

    checkVMStatus(data, el, fr) {
        $.ajax({
            type: "POST",
            url: "/ra_ajax/get_virtualized_state",
            data: JSON.stringify({ aid: data.recovery.appliance_id, device_id: data.recovery.device_id }),
            success: function (response) {
                if (!$.contains(document.documentElement, fr.flowcontainer[0])){
                    //Not certain what should happen here
                    return;
                }
                if (response.is_error) {
                    data.render.hasError = true;
                    if (fr.flowcontainer.is(":visible")) {
                        data.render.searchComplete = true;
                        fr.render();
                    }
                } else if (response.data.virtualized) {
                    data.render.format = data.recovery.virtualization.format;
                    if (response.data.vmdk_from_failover_disabled) {
                        // Vmdk from Failover is disabled, and we deal with local virtualization
                        data.recovery.virtualization.vmdk_disabled = true;
                        data.tmp.vmRunning = { tryAgain: 'setDevice' };
                        fr.goTo('vmRunning');
                    } else if (response.data.bmr) {
                        // We deal with BMR, go to error state
                        data.recovery.virtualization.bmr = true;
                        data.tmp.vmRunning = { tryAgain: 'setDevice' };
                        fr.goTo('vmRunning');
                    } else if (response.data.production) {
                        data.recovery.virtualization.production = true;
                        data.recovery.virtualization.pointTs = response.data.timestamp;
                        if (response.data.transition) {
                            // We are in transition state, go to error state
                            data.recovery.virtualization.transition = true;
                            data.tmp.vmRunning = { tryAgain: 'setDevice' };
                            fr.goTo('vmRunning');
                        } else if (response.data.running) {
                            // We deal with production running
                            data.recovery.virtualization.running = true;
                            fr.goTo('setJob');
                        } else {
                            // We deal with production that was stopped
                            data.recovery.virtualization.running = false;
                            // ...but check for exposed mounts in this case
                            getExposedMount(data, function(response) {
                                if (response.is_error == 0) {
                                    if (response.data.is_disk_exposed) {
                                        data.share_id = response.data.share_id;
                                        fr.goTo('revokeMount');
                                    } else {
                                        fr.goTo('setJob');
                                    }
                                } else {
                                    console.log('getExposedMount: unexpected error');
                                }
                            });
                        }
                    } else {
                        // Dealing with Test Failover, go to error state
                        data.recovery.virtualization.testfailover = true;
                        data.tmp.vmRunning = { tryAgain: 'setDevice' };
                        fr.goTo('vmRunning');
                    }
                } else {
                    // check for exposed mounts
                    getExposedMount(data, function(response) {
                        if (response.is_error == 0) {
                            if (response.data.is_disk_exposed) {
                                data.share_id = response.data.share_id;
                                if(response.data.waitLoad && response.data.format === data.recovery.virtualization.format){
                                    data.loadShare = true;
                                    fr.goTo('exportVm');
                                } else{
                                    fr.goTo('revokeMount');
                                }
                            } else {
                                data.recovery.virtualization.production = false;
                                fr.goTo('setJob');
                            }
                        } else {
                            console.log('getExposedMount: unexpected error');
                        }
                    });
                }
            },
            dataType: AJAX_DATA_TYPE_JSON,
            contentType: "application/json"
        }).fail(fr.defaultAJAXErrorHandler);
    }

    getUrl(data) {
        let apiEndpoint = "/api/localbrowsing/devices/";
        if (data.restore && data.restore.type) {
            if (data.restore.type === "cloud") {
                apiEndpoint = "/api/filebrowsing/devices/" + data.recovery.appliance_id;
            } else {
                apiEndpoint += "0/" + data.recovery.appliance_id;
            }
        } else if (data.recovery.virtualization && data.recovery.virtualization.location && EXPORT_TYPES.includes(data.recovery.virtualization.location)) {
            apiEndpoint = "/api/vmexport/devices/" + data.clientId + "/" + (data.applianceId ? data.applianceId : ZERO) + "/sva/" + data.recovery.virtualization.format;
            if (data.recovery.virtualization.type && data.recovery.virtualization.type === "dynamic") {
                apiEndpoint += "/1"
            }
        }

        return apiEndpoint;
    }

}
